<template>
  <div class="box">
    <aside class="sidebar">
      <div class="side-header" @click="clickHeader">主頁</div>
      <div class="side-box enable-scroll">
        <div v-for="item in data.filter((route) => route.id !== 2)" v-bind:key="item.id" class="side-title about-side"
          @click="clickTitle" :data-title="item.title" :data-content="item.content">
          {{ item.title }}
        </div>
      </div>
    </aside>

    <main class="main">
      <div v-if="show_content" class="main-title">{{ title }}</div>
      <div v-if="show_content" class="main-content text-gray enable-scroll" @click="handleAboutContentLinkClick">
        <div v-html="content"></div>
        <div v-if="show_version" class="app-version">v{{ app_version }}</div>
      </div>

      <div v-if="show_launch" class="launch">
        <Launch layout_cls="about-launch" icon_cls="about-icon" :show_time="show_time"></Launch>
      </div>
    </main>

  </div>
</template>

<script>
import Launch from "../../views/Launch";
import { handleAboutContentLinkClick as handleAboutContentLinkNavigation } from "@/utils/aboutContentLinks";
export default {
  name: "AboutContent",
  components: { Launch },
  props: {
    data: { type: Array }
  },
  mounted() {
    const inter = setInterval(function () {
      const ele = document.createEvent("MouseEvents");
      ele.initEvent("click", true, true);
      const objs = document.getElementsByClassName('about-side');
      if (objs.length > 0) {
        objs[0].dispatchEvent(ele);
        clearInterval(inter);
      }
    }, 1);

  },
  data() {
    return {
      title: '',
      content: '',
      app_version: process.env.VUE_APP_VERSION,
      show_content: true,
      show_launch: false,
      show_time: false,
      show_version: false,
    }
  },
  methods: {
    clickHeader: function () {
      this.clearSelected();
      this.show_content = false;
      this.show_launch = true;
      this.show_version = false;

      document.getElementsByClassName('side-header')[0].classList.add('side_selected');


    },
    clickTitle: function (e) {
      this.clearSelected();

      this.show_content = true;
      this.show_launch = false;
      this.show_version = e.target.dataset.title === '版本資訊';

      e.target.classList.add('side_selected')
      this.title = e.target.dataset.title;
      this.content = e.target.dataset.content;
    },
    handleAboutContentLinkClick: function (e) {
      handleAboutContentLinkNavigation(e);
    },
    clearSelected: function () {
      const objs = document.getElementsByClassName('about-side');
      for (let i = 0; i < objs.length; i++) {
        objs[i].classList.remove('side_selected')
      }

      document.getElementsByClassName('side-header')[0].classList.remove('side_selected')
      if (this.show_content) {
        document.getElementsByClassName('main-content')[0].scroll(0, 0)
      }

    }
  }
}
</script>

<style scoped>
.box {
  position: absolute;
  inset: 0;
  display: flex;
}

.sidebar {
  position: relative;
  flex: 0 0 20%;
  height: 100%;
}

.main {
  position: relative;
  box-sizing: border-box;
  width: 70%;
  height: calc(100% - 2rem);
  margin: 1rem 5% 1rem 5%;
  padding: 0 1rem;
}

.main-title {
  position: relative;
  color: #61005f;
  text-align: center;
  font-size: var(--ecs-font-md);
  line-height: 1.3;
  margin-bottom: clamp(0.75rem, 2vw, 1.25rem);
}

.main-content {
  height: calc(100% - 2rem);
  overflow-y: auto;
  font-size: var(--ecs-font-sm);
  line-height: 1.4;
  white-space: break-spaces;
}

.app-version {
  margin-top: clamp(0.75rem, 2vw, 1.25rem);
}

.launch {
  height: 100%;
}

@media (max-width: 720px) {
  .main {
    height: calc(100% - 2rem);
    margin: 1rem 5% 1rem 5%;
  }
}

.text-bold {
  color: black;
}
</style>
